export interface BodyBlock {
  h?: string;
  p: string[];
}

export interface Article {
  id: string;
  slug: string;
  category: string;
  title: string;
  excerpt: string;
  hero: string;
  author: string;
  authorRole: string;
  date: string;
  readMin: number;
  views: string;
  tags: string[];
  featured?: boolean;
  hot?: boolean;
  timeline?: string;
  body: BodyBlock[];
}

export const ARTICLES: Article[] = [
  {
    id: "a1",
    slug: "naodao-shake-lighting-bts",
    category: "bts",
    title: "那条NG了十七遍的推轨镜头，到底难在哪",
    excerpt:
      "一场只有三十秒的室内追逐，导演硬是拍了整整一个下午。副摄影师、灯光组与掌机围着一支三米长的滑轨反复争执，直到第三版灯光方案才让影子落在了导演想要的位置。",
    hero: "https://readdy.ai/api/search-image?query=cinematic%20film%20set%20behind%20the%20scenes%20with%20a%20dolly%20camera%20track%20and%20grip%20team%20adjusting%20lights%2C%20warm%20amber%20practical%20bulbs%20against%20deep%20charcoal%20shadow%2C%20thin%20atmospheric%20haze%2C%20moody%20editorial%20documentary%20photography%2C%20film%20grain%2C%20subtle%20golden%20rim%20lighting&width=1600&height=900&seq=cover-bts-naodao&orientation=landscape",
    author: "阿澈",
    authorRole: "拍摄组特约撰稿",
    date: "2026-08-19",
    readMin: 7,
    views: "1.8万",
    tags: ["滑轨", "灯光", "调度"],
    hot: true,
    body: [
      {
        h: "先做减法：为什么滑轨比手持更费力",
        p: [
          "片场第一天，导演就否掉了运动摄影师惯用的手持跟拍方案。理由是这场戏的情绪线需要‘稳中带刺’——镜头必须始终贴着人物，却又不能完全安抚观众。于是团队把希望寄托在一支三米长的电动滑轨上。",
          "看似稳妥的选择，却成了全组最难啃的骨头。狭长的走廊让滑轨只能布置在窗侧，可窗帘的透光角度每隔二十分钟就会变化一次，副摄影师不得不同时盯着监视器里的构图与窗外移动的云。",
        ],
      },
      {
        h: "十七遍NG：问题大多出在‘影子’",
        p: [
          "前六遍纯属镜头语言尝试，后十一遍几乎全部败给了人物脚边的影子。主光从45度落下时，主角转身的瞬间会把一条突兀的影子甩到墙上，与正片需要的纵深层次严重打架。",
          "灯光组最终撤掉了两支柔光，换成一面透光的漫反射布，并把地面的照度压低了整整两档。第二遍新方案后，副摄影只比了一个OK的手势——所有人都知道，这条成了。",
        ],
      },
      {
        h: "NG本身，才是最值钱的素材",
        p: [
          "收工后的回放会上，大家发现第十五遍的表演其实比最终成片更松弛。导演笑着把那条单独存了下来，说这版‘不像演的’也许会剪进花絮作为彩蛋。",
          "这正是现场的意义：你以为十七遍是在重复，其实每一遍都在让镜头离人物更近一点。",
        ],
      },
    ],
  },
  {
    id: "a2",
    slug: "midnight-shortfilm-rain-day",
    category: "story",
    title: "没有预算的雨戏：那场暴雨是等来的，也是借来的",
    excerpt:
      "天气预报里原本只是‘多云转晴’，可制片第二天清晨打来电话时，语气里藏不住兴奋——一场强对流正在逼近取景地。全组临时改了通告，抢在雨停前用五小时拍完了全片最贵的一场戏。",
    hero: "https://readdy.ai/api/search-image?query=film%20crew%20shooting%20in%20a%20rainy%20night%20alley%20with%20umbrellas%20and%20practical%20lanterns%2C%20wet%20reflective%20pavement%2C%20warm%20streetlight%20glow%20against%20cool%20darkness%2C%20cinematic%20behind%20the%20scenes%20photography%2C%20film%20grain%2C%20atmospheric%20and%20candid&width=1600&height=900&seq=cover-story-rain&orientation=landscape",
    author: "小满",
    authorRole: "执行制片",
    date: "2026-08-12",
    readMin: 6,
    views: "1.2万",
    tags: ["雨戏", "制片", "突发调度"],
    hot: true,
    body: [
      {
        h: "制片人的必修课：追着云跑",
        p: [
          "雨，是所有低成本短片里最贵的道具。真正的洒水车按天计费，而这场戏偏偏需要一场‘没人看得到管子在喷’的雨。唯一的答案，是等一场真雨。",
          "制片组在开拍前一周就锁定了三个备选机位，每天清晨更新两版天气模型。暴雨来那晚，他们从通知到全体抵达现场只用了四十分钟。",
        ],
      },
      {
        h: "五小时的疯狂工作流",
        p: [
          "雨太大撑不了器材，灯光组就用两条防雨布搭出临时‘帐篷摄影棚’，只留下正对人物的一扇缝。录音师把毛衣裹在挑杆上吸水，摄影师则把手套剪了指尖，保证每一次聚焦都不被打湿打断。",
          "五小时后雨势渐小，导演喊收工时，现场安静得像按了暂停键——没有人说话，只听见雨点敲在防水布上的声音，像一句迟到的杀青祝福。",
        ],
      },
      {
        h: "那场雨教会了我们什么",
        p: [
          "后来成片里，观众只看到一场漂亮的雨，看不到它背后的临时改通告、湿透的鞋和两台进了水的监视器。可这些‘看不见’，恰恰就是短片真正的制作成本。",
        ],
      },
    ],
  },
  {
    id: "a3",
    slug: "director-talk-silent-scene",
    category: "interview",
    title: "导演对谈｜周野：沉默比台词更早写完，我就知道这部片子对了",
    excerpt:
      "从编剧转行当导演的第三年，周野带来了自己的第十一部短片。我们聊了那场全程无对白的高潮戏，也聊了他为什么坚持让演员先‘演给空气看’。",
    hero: "https://readdy.ai/api/search-image?query=documentary%20portrait%20of%20a%20young%20film%20director%20in%20a%20dark%20editing%20room%20facing%20a%20glowing%20monitor%2C%20profile%20lit%20by%20warm%20amber%20key%20light%2C%20silhouettes%20of%20film%20posters%20behind%2C%20moody%20cinematic%20tone%2C%20film%20grain%2C%20editorial%20journalism%20photography&width=1600&height=900&seq=cover-interview-zhou&orientation=landscape",
    author: "陆一白",
    authorRole: "主笔 · 导演访谈",
    date: "2026-07-28",
    readMin: 9,
    views: "2.3万",
    tags: ["导演访谈", "对白", "表演指导"],
    featured: true,
    hot: true,
    body: [
      {
        h: "一场原本写满台词的戏，为什么最后删干净了",
        p: [
          "初稿里那场高潮戏有四段长台词，信息量很大，但读完总觉得哪里‘松了’。周野说自己把剧本倒扣在桌上三天，重新读时发现，真正让人心揪的其实是人物最后那个没有说出口的动作。",
          "‘剪辑台上，我第一次把配音轨静音放映，全组都安静了。当一段戏在完全没有声音的情况下依然成立，它就值得一句台词都不要。’他这样解释这次大胆的减法。",
        ],
      },
      {
        h: "让演员‘先演给空气看’",
        p: [
          "开拍前的排练，周野从不安排对手戏。他要每位演员单独进入空荡的房间里，对着墙完成整场戏。‘你必须先建立自己的心理节奏，才谈得上和对手呼吸同步。很多人误以为表演是对戏，其实第一步永远是独处。’",
          "这种看似反常的排练，最终在成片里换来了令人信服的停顿与呼吸，也是这部短片最被观众记住的段落。",
        ],
      },
      {
        h: "给想拍第一部短片的人一句话",
        p: [
          "‘别等到万事俱备。你的第一部片子最重要的任务是拍完，而不是拍好。很多导演死在第二部，是因为第一部的完美想象耗光了所有勇气。’他顿了顿，‘先把它做出来，再让它变好。’",
        ],
      },
    ],
  },
  {
    id: "a4",
    slug: "set-diary-last-shooting-day",
    category: "diary",
    title: "片场日记｜杀青那天，我们谁都没有哭",
    excerpt:
      "原以为杀青会是一场盛大的告别，实际上它只是制片默默订了五十份盒饭，摄影最后清点了一遍电池。我在副摄影机位后记下这一切，想留住那种还没来得及伤感的忙碌。",
    hero: "https://readdy.ai/api/search-image?query=film%20crew%20wrapping%20on%20the%20last%20shooting%20day%20at%20dusk%2C%20grip%20packing%20light%20stands%20and%20camera%20case%2C%20golden%20hour%20light%20through%20a%20doorway%2C%20documentary%20style%20cinematic%20photography%2C%20warm%20amber%20tone%2C%20film%20grain%2C%20candid%20emotional%20quiet&width=1600&height=900&seq=cover-diary-lastday&orientation=landscape",
    author: "十七",
    authorRole: "副摄影师 · 片场日记",
    date: "2026-07-16",
    readMin: 5,
    views: "9400",
    tags: ["杀青", "片场日记", "收尾"],
    body: [
      {
        h: "早上八点，和往常一样",
        p: [
          "最后一天没有谁提前到，也没有谁迟到。制片把新的通告贴好时，大家才发现上面写着一句被围住画了圈的备注：‘今日含杀青聚餐，请勿提前安排离组。’",
          "灯光师照例最早开工，把昨晚留的两块反光板收进袋子时轻声说了句‘再用不到了’，像是自言自语。",
        ],
      },
      {
        h: "最后一条，比想象中平静",
        p: [
          "下午四点十七分，导演喊出最后一个‘过’。没有掌声雷动，只有录音师放下挑杆时那一声轻响。有人搬来一块白板，让全组签名，笔传了一圈，最后落在编剧手上。",
          "她写的是：‘谢谢你们，把我脑子里的雨，变成了真的。’",
        ],
      },
      {
        h: "夜里那顿不算丰盛的饭",
        p: [
          "聚餐订在一家巷子深处的小店，桌上摆着五十份盒饭和两箱汽水。没有人说漂亮话，聊的全是下一次合作‘别再拍雨戏’的玩笑。",
          "回去的地铁上，我翻着白板照片忽然明白：真正好的告别，都来不及伤感，只会让人急着想下一次怎么见面。",
        ],
      },
    ],
  },
  {
    id: "a5",
    slug: "making-of-sound-design",
    category: "special",
    title: "制作特辑｜一部全靠环境声撑起来的惊悚片",
    excerpt:
      "没有配乐、没有尖叫，这部电影最让人后背发凉的竟是风扇的转动声。声音设计师林霜拆解了全片的声场设计，带我们走进那间堆满老录音机的房间。",
    hero: "https://readdy.ai/api/search-image?query=sound%20designer%20working%20in%20a%20dim%20studio%20surrounded%20by%20analog%20tape%20recorders%20and%20mixers%2C%20close%20up%20of%20hands%20on%20faders%2C%20warm%20desk%20lamp%20glow%2C%20dark%20moody%20cinematic%20documentary%20photography%2C%20film%20grain&width=1600&height=900&seq=cover-special-sound&orientation=landscape",
    author: "阿澈",
    authorRole: "声音专栏",
    date: "2026-07-02",
    readMin: 8,
    views: "1.6万",
    tags: ["声音设计", "环境声", "制作特辑"],
    featured: true,
    body: [
      {
        h: "把‘安静’当成主角来设计",
        p: [
          "大多数惊悚片靠低频配乐制造紧张，而这部短片反其道而行：导演要求正片前二十分钟‘尽量没有音乐’。这意味着所有情绪压力都要由环境声独立完成。",
          "林霜的解决方式，是把房间里的每一个物理噪音都‘演’了一遍——风扇的叶片、老式水壶的沸腾、甚至窗外偶尔驶过的车，都被当作角色来调度。",
        ],
      },
      {
        h: "混音室里最贵的一件道具",
        p: [
          "为了还原一扇吱呀作响的木门，林霜跑遍旧货市场淘回三扇不同年代的旧门，反复铰合比对，最后才选定那声‘足够像记忆里家里那扇’的音色。",
          "‘观众不会知道它来自哪里，但他们的身体会知道——这正是声音最迷人的地方。’",
        ],
      },
      {
        h: "给独立创作者的三个声音建议",
        p: [
          "第一，宁可现场收音素材单薄，也别放过每一个环境底噪，它们是后期最值钱的材料。第二，给‘沉默’留出节奏，声音的戏剧性往往藏在声与声之间的停顿里。第三，混音时戴两副不同的耳机交叉检查，别让一套设备骗了你的耳朵。",
        ],
      },
    ],
  },
  {
    id: "a6",
    slug: "creative-process-from-script-to-frame",
    category: "process",
    title: "从三页梗概到九个镜头：一个故事是怎么长出来的",
    excerpt:
      "很多新人以为创作是从第一句剧本开始的，其实它往往从一个画面、一个声音、甚至一句没头没尾的抱怨开始。我们跟拍了编剧老邱的创作全流程。",
    hero: "https://readdy.ai/api/search-image?query=writer%20working%20on%20a%20script%20at%20a%20cluttered%20desk%20with%20sticky%20notes%20and%20a%20laptop%20in%20a%20warmly%20lit%20study%2C%20coffee%20mug%20and%20pencils%2C%20moody%20evening%20light%2C%20cinematic%20documentary%20photography%2C%20film%20grain%2C%20intimate%20creative%20atmosphere&width=1600&height=900&seq=cover-process-script&orientation=landscape",
    author: "老邱",
    authorRole: "编剧 · 创作手记",
    date: "2026-06-20",
    readMin: 7,
    views: "1.1万",
    tags: ["剧本", "分镜", "创作过程"],
    body: [
      {
        h: "一切的起点，是一句抱怨",
        p: [
          "去年秋天，老邱在菜市场听见一位摊主对熟人抱怨‘如今连个好好说话的人都没有’。这句无心的话在他脑子里盘旋了一整晚，最后长成了这部片子的核心——两个陌生人在深夜便利店里的十分钟对话。",
          "他先把这句话写成三页梗概，再倒过来反推人物：谁会说这种话、他为什么在深夜还醒着、他真正想对谁说。人物一旦立住，故事就自动往前跑了。",
        ],
      },
      {
        h: "把剧本翻译成镜头语言",
        p: [
          "老邱不迷信分镜表，他习惯在剧本空白处随手画九宫格。每一场戏，他都先问自己三个问题：观众此时最想看人物的脸还是手？镜头要贴得多近？这格画面能独立讲清多少信息？",
          "‘九个镜头是这部片子的上限。倒不是因为技法，而是我相信，说得少的短片往往记得更久。’",
        ],
      },
      {
        h: "创作不是灵感的等待，是动作的积累",
        p: [
          "老邱给自己定了一条规矩：每天至少写两百字，哪怕写的是废话。‘灵感像水库，你得先有存量，才谈得上放水。很多人的瓶颈不是没想法，是启动成本太高，把动笔想得太神圣了。’",
        ],
      },
    ],
  },
  {
    id: "a7",
    slug: "bts-dog-star-editing-cut",
    category: "bts",
    title: "剪辑室里的抉择：那十分钟我们删掉的，比留下的更珍贵",
    excerpt:
      "成片只有十二分钟，剪辑房里却躺着一小时四十分钟的素材。剪辑师决定删除一场全组都心爱的戏时，导演在监视器前沉默了很久，最后只说了一个字：‘剪。’",
    hero: "https://readdy.ai/api/search-image?query=film%20editor%20sitting%20in%20a%20dark%20edit%20suite%20before%20two%20monitors%20with%20timeline%20timeline%20visible%2C%20coffee%20and%20notebooks%2C%20warm%20dim%20monitor%20glow%20illuminating%20the%20room%2C%20cinematic%20behind%20the%20scenes%20photography%2C%20film%20grain%2C%20moody%20focused%20atmosphere&width=1600&height=900&seq=cover-bts-cut&orientation=landscape",
    author: "Kiki",
    authorRole: "剪辑师 · 拍摄花絮",
    date: "2026-06-05",
    readMin: 6,
    views: "8700",
    tags: ["剪辑", "取舍", "成片"],
    body: [
      {
        h: "一小时四十分钟，是十二分钟的十四倍",
        p: [
          "前期拍摄为了给剪辑留足余地，导演几乎是‘什么都要’地拍完了整个剧本。等素材真正摊上剪辑台，那份慷慨立刻变成了甜蜜的负担。",
          "第一版粗剪长达二十八分钟，看完后全组都沉默——它忠实，却拖沓。真正的好故事不该只是把该讲的都讲完。",
        ],
      },
      {
        h: "最爱的那场戏，成了第一个牺牲品",
        p: [
          "那场戏里有一只会抢镜的狗，全组为它笑场了一整天。可它承担的功能，和另一场更安静的戏重复了。Kiki把两段并列放在导演面前时，问题只有一个：故事想被记住的是热闹，还是情绪。",
          "导演盯着那场戏看了十分钟，最后合上屏幕说：‘剪。它很可爱，但成片不需要它。’全场没人反对，只有制片小声说了句‘替那只狗难过一下’。",
        ],
      },
      {
        h: "剪辑的本质，是替观众做减法",
        p: [
          "删完那场戏，成片反而松快了。Kiki说，剪辑师最重要的工作不是保留多少，而是有勇气删掉多少：‘你对素材的感情越深，越要警惕——观众不会因为你和素材的羁绊，就原谅一段多余的戏。’",
        ],
      },
    ],
  },
  {
    id: "a8",
    slug: "story-fake-sunrise-golden-hour",
    category: "story",
    title: "为了五分钟的‘假日出’，灯光组准备了三天",
    excerpt:
      "剧组预算不够拉大队去追日出，灯光组长却拍胸脯说‘我能把日出搬进摄影棚’。三天后，他用九盏灯和一张渐变滤纸，造出了连演员都分不清真假的清晨。",
    hero: "https://readdy.ai/api/search-image?query=lighting%20crew%20building%20an%20artificial%20sunrise%20inside%20a%20studio%20with%20softbox%20panels%20and%20gels%20casting%20warm%20golden%20gradient%20light%2C%20silhouettes%20of%20crew%2C%20haze%20in%20air%2C%20cinematic%20documentary%20photography%2C%20film%20grain&width=1600&height=900&seq=cover-story-sunrise&orientation=landscape",
    author: "小满",
    authorRole: "执行制片",
    date: "2026-05-24",
    readMin: 5,
    views: "1.3万",
    tags: ["灯光", "合成", "幕后故事"],
    body: [
      {
        h: "日出，是制片预算表上最贵的四个字",
        p: [
          "真实日出的拍摄窗口每天只有约二十分钟，转场成本高到惊人。美术与摄影合算了三版方案后，组长立下军令状：把日出搬进棚里，一次拍够。",
          "这不是偷懒，而是把不可控的天光，变成了可控的布光。对短片来说，可控比浪漫更接近生产力。",
        ],
      },
      {
        h: "九盏灯造一场清晨",
        p: [
          "他用三盏顶灯模拟地平线以下的散射光，两盏侧灯扮作破晓的橙，剩下四盏与一张渐变滤纸合作，让光色从冷灰缓缓过渡到暖金。演员走位每改一次，灯位就要重调半小时。",
          "开机那天，当那句‘日出’喊出口，监视器里的画面让现场安静下来——没人相信头顶只是一块黑色幕布。",
        ],
      },
      {
        h: "假的日出，真的情绪",
        p: [
          "成片里那场戏只有五分钟，可观众会记得那种说不清道不明的‘清晨感’。它提醒所有创作者：打动人的从不是器材或自然，而是你愿为一段情绪付出多少准备的决心。",
        ],
      },
    ],
  },
  {
    id: "a9",
    slug: "interview-grip-say-again",
    category: "interview",
    title: "对话摄影指导｜邵宁：好镜头不是靠器材，是靠‘停一下’",
    excerpt:
      "从业十四年的摄影指导邵宁聊起自己的拍摄哲学时说，他最喜欢的两个字是‘停一下’。在人人追求更快更稳的片场，他为什么总叫停？",
    hero: "https://readdy.ai/api/search-image?query=cinematographer%20holding%20a%20film%20camera%20and%20looking%20through%20the%20viewfinder%20on%20a%20set%20at%20dusk%2C%20crew%20silhouetted%20behind%2C%20warm%20practical%20lights%2C%20cinematic%20documentary%20photography%2C%20film%20grain%2C%20intimate%20and%20reflective&width=1600&height=900&seq=cover-interview-shao&orientation=landscape",
    author: "陆一白",
    authorRole: "主笔 · 导演访谈",
    date: "2026-05-09",
    readMin: 8,
    views: "2.0万",
    tags: ["摄影指导", "镜头", "表演"],
    featured: true,
    body: [
      {
        h: "器材越好，越要小心被它牵着走",
        p: [
          "邵宁见过太多被新镜头、新稳定器绑架的创作者：器材越先进，反而越舍不得停下构图，最后拍出一堆‘很稳却不知所云’的画面。",
          "‘稳定器不是用来让镜头无聊的。’他把这句话写在了工作手册第一页。",
        ],
      },
      {
        h: "叫停，是为了听见现场",
        p: [
          "他会在一个镜头拍得正顺时突然喊停。起初组员以为是出了差错，后来才明白：他只是想让大家从‘完成任务’的惯性里抽身，重新听一遍现场的声音，重新看一眼此刻的光。",
          "‘灵感不是催出来的，是停出来的。’这句口头禅如今写在了每一位跟机摄影的场记本上。",
        ],
      },
      {
        h: "给青年摄影的一句话",
        p: [
          "‘先学会看，再学会拍。很多人第一台机器到手就急着拍遍天下，其实最该做的，是把同一扇窗在不同光线下看上一整天。镜头里装得下的世界，永远比你想象的多。’",
        ],
      },
    ],
  },
];

export function getArticleBySlug(slug: string): Article | undefined {
  return ARTICLES.find((a) => a.slug === slug);
}

export function articlesByCategory(category: string): Article[] {
  return ARTICLES.filter((a) => a.category === category);
}

export function relatedArticles(article: Article, count = 3): Article[] {
  const same = ARTICLES.filter((a) => a.category === article.category && a.id !== article.id);
  const others = ARTICLES.filter((a) => a.category !== article.category && a.id !== article.id);
  return [...same, ...others].slice(0, count);
}

export const FEATURED = ARTICLES.filter((a) => a.featured);
export const HOT_ARTICLES = ARTICLES.filter((a) => a.hot);
export const LATEST_ARTICLES = [...ARTICLES].reverse();